import React from 'react'

import { Button, CTALink, IconButton } from '@pb/components'
import { isValueOf } from '@pb/utils'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { Link as ReactLink } from 'react-router-dom'

import { REACT_ROUTES } from 'App/constants'

const isReactRoute = (routeToCheck): boolean =>
  !!Object.keys(REACT_ROUTES).find((key) => REACT_ROUTES[key].path === routeToCheck)
/**
 * renders button, a-tag or Link to (if react route)
 */
const Action: React.FC<any> = ({ Tag, link, children, uiComponent, className, ...props }) => {
  const isLinkReactRoute = link && (isValueOf(REACT_ROUTES, link) || isReactRoute(link))
  const dynamicLinkProps: any = {}
  let DynamicComponent

  if (isLinkReactRoute) {
    dynamicLinkProps.to = link
    dynamicLinkProps.Tag = ReactLink
  } else if (link && !isLinkReactRoute) {
    dynamicLinkProps.href = link
    dynamicLinkProps.Tag = 'a'
  } else {
    dynamicLinkProps.Tag = Tag || 'button'
  }

  switch (uiComponent) {
    case 'Button':
      DynamicComponent = Button
      break
    case 'IconButton':
      DynamicComponent = IconButton
      break
    default:
      DynamicComponent = CTALink
      break
  }

  return (
    <DynamicComponent className={cn(className)} Tag={Tag} {...dynamicLinkProps} {...props}>
      {children}
    </DynamicComponent>
  )
}

Action.propTypes = {
  uiComponent: PropTypes.oneOf(['Button', 'CTALink', 'IconButton']),
  link: PropTypes.string,
  children: PropTypes.node.isRequired,
  Tag: PropTypes.string,
}

export default Action
